import Main from '@/layout/main.vue'
import Blank from '@/layout/blank.vue'
const routes = [
    {
        path: '/article',
        name: 'article',
        meta: { title: '帮助' },
        redirect: '/article/lists',
        component: Main,
        children: [
            {
                path: '/article/lists',
                name: 'article',
                meta: {
                    title: '帮助文档',
                    parentPath: '/article',
                    icon: 'el-icon-guide',
                    permission: ['view']
                },
                component: () => import('@/views/article/lists.vue')
            },
            {
                path: '/article/article_edit',
                name: 'article_edit',
                meta: {
                    hidden: true,
                    title: '帮助文档',
                    parentPath: '/article',
                    prevPath: '/article/lists',
                },
                component: () => import('@/views/article/article_edit.vue')
            },
            {
                path: '/article/category_lists',
                name: 'category_lists',
                meta: {
                    title: '文档分类',
                    parentPath: '/article',
                    icon: 'el-icon-s-operation',
                    permission: ['view']
                },
                component: () => import('@/views/article/category_lists.vue')
            }
        ]
    }
]

export default routes